import type { ICatalog, ILocalizedText } from '@platform/core/types';
import type { IOrderedSummary } from '../../shell/IOrderedSummary';
import { recordTypeOrder } from '../../shell/recordTypeOrder';
import { moduleRank } from '../customize/moduleRank';
import type { IAuditModule } from './IAuditModule';

/**
 * Пункти «Усі модулі» журналу аудиту (прототип v4 auModEls: ws.modules — кожен тип запису простору окремим «модулем»): типи записів
 * установлених модулів у порядку прототипу для простору (`order` каталогу; тип без `order` у такому каталозі не належить ws.modules
 * простору й не показується); назва — головний тип як модуль, дочірній — назва типу. Чиста функція.
 */
export function auditModules(catalog: ICatalog | undefined, label: (text: ILocalizedText | null | undefined) => string): IAuditModule[] {
  const installed = (catalog?.modules ?? []).filter((m) => m.installed);
  const ordered = installed.some((m) => m.recordTypes.some((r) => typeof (r as IOrderedSummary).order === 'number'));
  const at = recordTypeOrder(catalog, moduleRank());
  return installed
    .flatMap((m) => m.recordTypes
      .filter((r) => !ordered || typeof (r as IOrderedSummary).order === 'number')
      .map((r) => ({ key: r.key, label: (r.main ? label(m.name) : label(r.name)) || r.key })))
    .sort((a, b) => at(a.key) - at(b.key));
}
